import { render, staticRenderFns } from "./addressEditJm.vue?vue&type=template&id=29455594&scoped=true&"
import script from "./addressEditJm.vue?vue&type=script&lang=js&"
export * from "./addressEditJm.vue?vue&type=script&lang=js&"
import style0 from "./addressEditJm.vue?vue&type=style&index=0&id=29455594&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29455594",
  null
  
)

export default component.exports